/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import './styles.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { useSelector } from 'react-redux';
import { LoadingIndicator } from '@components';
import { ItemMenuAtendimentoVirtual } from './components/itemMenu';
import {
  CONTRACHEQUE,
  EXTRADO_SALDO_CONTAS,
  MEUS_DADOS,
  EXTRADO_SALDO_CONTAS_ASSISTIDO_PENSIONISTA,
  ABONO_ANUAL,
  INFORME_RENDIMENTOS,
  SIMULADOR_ABSOLUTE_PATH,
  PARCELA_ADICIONAL,
  CONTRATOS_ABSOLUTE_PATH,
  CALENDARIO_EMPRESTIMO,
  SOLICITACAO_RESGATE_PARCIAL_FORMULARIO,
  TROCA_DE_PERFIL_ABSOLUTE_PATH,
  ALTERAR_PC_ABSOLUTE_PATH,
} from '../../../utils/paths';

const links = [
  {
    identificador: 'att_dados_cadastrais',
    destino: MEUS_DADOS,
  },
  {
    identificador: 'contracheque',
    destino: CONTRACHEQUE,
  },
  {
    identificador: 'extrato_conta_ativo',
    destino: EXTRADO_SALDO_CONTAS,
  },
  {
    identificador: 'extrato_aposentadoria',
    destino: EXTRADO_SALDO_CONTAS,
  },
  {
    identificador: 'extrato_pensionista_assistido',
    destino: EXTRADO_SALDO_CONTAS_ASSISTIDO_PENSIONISTA,
  },
  {
    identificador: 'simular_emprestimo',
    destino: SIMULADOR_ABSOLUTE_PATH,
  },
  {
    identificador: 'contratos_aberto',
    destino: CONTRATOS_ABSOLUTE_PATH,
  },
  {
    identificador: 'informe_rendimento',
    destino: INFORME_RENDIMENTOS,
  },
  {
    identificador: 'incluir_excluir_beneficiario',
    destino: MEUS_DADOS,
  },
  {
    identificador: 'resgate_parcial',
    destino: SOLICITACAO_RESGATE_PARCIAL_FORMULARIO,
  },
  {
    identificador: 'abono_anual',
    destino: ABONO_ANUAL,
  },
  {
    identificador: 'incluir_excluir_dependente',
    destino: MEUS_DADOS,
  },
  {
    identificador: 'parcela_adicional',
    destino: PARCELA_ADICIONAL,
  },
  {
    identificador: 'percentual_contribuicao',
    destino: ALTERAR_PC_ABSOLUTE_PATH,
  },
  {
    identificador: 'calendario_pagamento',
    destino: CALENDARIO_EMPRESTIMO,
  },
  {
    identificador: 'atendimento',
    destino:
      'https://institucional.forluz.org.br/CentralDeAtendimento/central-atendimento',
  },
  {
    identificador: 'alterar_perfil',
    destino: TROCA_DE_PERFIL_ABSOLUTE_PATH,
  },
];

export const AtendimentoVirtualCard = () => {
  const [linksDisponiveis, setLinksDisponiveis] = useState([]);
  const { data: itensMenuAtendimentoVirtual, loading } = useSelector(
    (state) => state.configs.menuAtendimentoVirtual
  );

  useEffect(() => {
    if (itensMenuAtendimentoVirtual) {
      setLinksDisponiveis(
        itensMenuAtendimentoVirtual.map((menu) => {
          const link = links.find(
            (item) => item.identificador === menu.identificador
          );
          if (link) {
            return {
              ...menu,
              destino: link.destino,
            };
          }
          return {};
        })
      );
    }
  }, [itensMenuAtendimentoVirtual, setLinksDisponiveis]);

  return (
    <div>
      {!loading ? (
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="col-lg-3 d-none d-lg-block">
                <p className="labelTituloSuperior">Atendimento</p>
                <p className="labelTituloInferior">Virtual</p>
              </div>

              <div className="col-lg-9 col-12 justify-content-between d-none d-lg-flex d-md-flex">
                {linksDisponiveis
                  .filter((obj) => Object.keys(obj).length > 0)
                  .map((link) => {
                    return (
                      <ItemMenuAtendimentoVirtual
                        key={link.identificador}
                        icone={link.icone}
                        titulo={link.titulo}
                        destino={link.destino}
                      />
                    );
                  })}
              </div>
              <Swiper
                className="d-lg-none d-md-none"
                slidesPerView={1}
                spaceBetween={10}
                pagination={{
                  clickable: false,
                }}
                breakpoints={{
                  250: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  350: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },
                  450: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                  },
                }}
                modules={[Pagination]}
              >
                {linksDisponiveis
                  .filter((obj) => Object.keys(obj).length > 0)
                  .map((link) => {
                    return (
                      <SwiperSlide key={link.identificador}>
                        <ItemMenuAtendimentoVirtual
                          key={link.destino}
                          icone={link.icone}
                          titulo={link.titulo}
                          destino={link.destino}
                        />
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            </div>

            <hr className="background-primary mt-4 d-none d-lg-block" />
          </div>
        </div>
      ) : (
        <LoadingIndicator />
      )}
    </div>
  );
};
